import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVehicle, IVehicleInitialState } from "./vehicleModel";
import { ActiveInactiveVehicle, createVehicle, deleteVehicle, getAllActiveVehicle, getAllVehicle, getVehicleByID, updateVehicle } from "./services/vehicle.service";

const initialState: IVehicleInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  VehicleList: [],
  VehicleID: null,
  VehicleDetail: {
    CityID: null,
    VehicleTypeID: null,
    NoOfSeats: null,
    KmPerDay: null,
    RatePerKm: null,
    DriverAllowancePerDay: null,
    PickUpWithinCity: null,
    DropWithinCity: null,
    EightHrEightyKmWithinCity: null,
    IsActive: 1,
  },
};

const vehicleSlice = createSlice({
  name: "vehicle",
  initialState,
  reducers: {
    clearVehicleDetails: (state) => {
      state.VehicleDetail = initialState.VehicleDetail;
    },
    setVehicleID: (state, action) => {
      state.VehicleID = action.payload;
    },
    clearVehicleID: (state) => {
      state.VehicleID = initialState.VehicleID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllVehicle.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllVehicle.fulfilled,
      (state, action: PayloadAction<IVehicle[]>) => {
        state.loading = false;
        state.VehicleList = action.payload || [];
      }
    );
    builder.addCase(getAllVehicle.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VehicleList = [];
    });
    builder.addCase(createVehicle.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createVehicle.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createVehicle.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateVehicle.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateVehicle.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateVehicle.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteVehicle.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteVehicle.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteVehicle.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getVehicleByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getVehicleByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.VehicleDetail = action.payload;
    });
    builder.addCase(getVehicleByID.rejected, (state, action) => {
      state.formLoading = false;
      state.VehicleDetail = initialState.VehicleDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveVehicle.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveVehicle.fulfilled,
      (state, action: PayloadAction<IVehicle[]>) => {
        state.loading = false;
        state.VehicleList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveVehicle.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VehicleList = [];
    });
    builder.addCase(ActiveInactiveVehicle.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveVehicle.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveVehicle.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearVehicleDetails, clearVehicleID, setVehicleID } =
  vehicleSlice.actions;
export default vehicleSlice.reducer;
